import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import loadingArt from "../../../assets/loading.png";

/* Brand loader: Mr. MilliyO gently bobbing over a milling shadow, with
   three gold "grain" dots. Use inline (lists, cards) or full-screen. */
export function MilliyoLoader({ size = 96, label = "Loading…" }) {
  return (
    <div className="milliyo-loader" role="status" aria-label={label}>
      <img src={loadingArt} alt="" style={{ height: size }} className="milliyo-loader-art" />
      <div className="milliyo-loader-shadow" />
      <div className="milliyo-loader-dots">
        <span /><span /><span />
      </div>
    </div>
  );
}

export function MilliyoLoaderOverlay() {
  return (
    <div className="milliyo-loader-overlay">
      <MilliyoLoader size={110} />
    </div>
  );
}

/* Shows the brand loader briefly on every route change inside the admin
   shell — the "moving between menus" moment. */
export function NavTransitionLoader() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) { first.current = false; return; }
    setVisible(true);
    const t = setTimeout(() => setVisible(false), 450);
    return () => clearTimeout(t);
  }, [pathname]);

  if (!visible) return null;
  return <MilliyoLoaderOverlay />;
}
